
import React from 'react';
import { Route } from 'react-router-dom';

// Import location bennes geographic routes with lazy loading
const LazyLocationBennesAveyron = React.lazy(() => import("@/pages/nos-services/location-bennes/LocationBennesAveyron"));
const LazyLocationBennesHauteGaronne = React.lazy(() => import("@/pages/nos-services/location-bennes/LocationBennesHauteGaronne"));
const LazyLocationBennesTarn = React.lazy(() => import("@/pages/nos-services/location-bennes/LocationBennesTarn"));
const LazyLocationBennesLot = React.lazy(() => import("@/pages/nos-services/location-bennes/LocationBennesLot"));
const LazyLocationBennesCantal = React.lazy(() => import("@/pages/nos-services/location-bennes/LocationBennesCantal"));
const LazyLocationBennesLozere = React.lazy(() => import("@/pages/nos-services/location-bennes/LocationBennesLozere"));
const LazyLocationBennesHerault = React.lazy(() => import("@/pages/nos-services/location-bennes/LocationBennesHerault"));
const LazyLocationBennesTarnEtGaronne = React.lazy(() => import("@/pages/nos-services/location-bennes/LocationBennesTarnEtGaronne"));
const LazyLocationBennesValDOise = React.lazy(() => import("@/pages/nos-services/location-bennes/LocationBennesValDOise"));
const LazyLocationBennesPuyDeDome = React.lazy(() => import("@/pages/nos-services/location-bennes/LocationBennesPuyDeDome"));

// Import demolition geographic routes with lazy loading
const LazyDemolitionAveyron = React.lazy(() => import("@/pages/nos-services/demolition/DemolitionAveyron"));
const LazyDemolitionHauteGaronne = React.lazy(() => import("@/pages/nos-services/demolition/DemolitionHauteGaronne"));
const LazyDemolitionTarn = React.lazy(() => import("@/pages/nos-services/demolition/DemolitionTarn"));
const LazyDemolitionLot = React.lazy(() => import("@/pages/nos-services/demolition/DemolitionLot"));
const LazyDemolitionCantal = React.lazy(() => import("@/pages/nos-services/demolition/DemolitionCantal"));
const LazyDemolitionLozere = React.lazy(() => import("@/pages/nos-services/demolition/DemolitionLozere"));
const LazyDemolitionHerault = React.lazy(() => import("@/pages/nos-services/demolition/DemolitionHerault"));
const LazyDemolitionTarnEtGaronne = React.lazy(() => import("@/pages/nos-services/demolition/DemolitionTarnEtGaronne"));
const LazyDemolitionValDOise = React.lazy(() => import("@/pages/nos-services/demolition/DemolitionValDOise"));

export const LocationBennesGeographicRoutes = () => [
  <Route key="/nos-services/location-bennes/aveyron" path="/nos-services/location-bennes/aveyron" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyLocationBennesAveyron />
    </React.Suspense>
  } />,
  <Route key="/nos-services/location-bennes/haute-garonne" path="/nos-services/location-bennes/haute-garonne" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyLocationBennesHauteGaronne />
    </React.Suspense>
  } />,
  <Route key="/nos-services/location-bennes/tarn" path="/nos-services/location-bennes/tarn" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyLocationBennesTarn />
    </React.Suspense>
  } />,
  <Route key="/nos-services/location-bennes/lot" path="/nos-services/location-bennes/lot" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyLocationBennesLot />
    </React.Suspense>
  } />,
  <Route key="/nos-services/location-bennes/cantal" path="/nos-services/location-bennes/cantal" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyLocationBennesCantal />
    </React.Suspense>
  } />,
  <Route key="/nos-services/location-bennes/lozere" path="/nos-services/location-bennes/lozere" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyLocationBennesLozere />
    </React.Suspense>
  } />,
  <Route key="/nos-services/location-bennes/herault" path="/nos-services/location-bennes/herault" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyLocationBennesHerault />
    </React.Suspense>
  } />,
  <Route key="/nos-services/location-bennes/tarn-et-garonne" path="/nos-services/location-bennes/tarn-et-garonne" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyLocationBennesTarnEtGaronne />
    </React.Suspense>
  } />,
  <Route key="/nos-services/location-bennes/val-doise" path="/nos-services/location-bennes/val-doise" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyLocationBennesValDOise />
    </React.Suspense>
  } />,
  <Route key="/nos-services/location-bennes/puy-de-dome" path="/nos-services/location-bennes/puy-de-dome" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyLocationBennesPuyDeDome />
    </React.Suspense>
  } />
];

export const DemolitionGeographicRoutes = () => [
  <Route key="/nos-services/demolition/aveyron" path="/nos-services/demolition/aveyron" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyDemolitionAveyron />
    </React.Suspense>
  } />,
  <Route key="/nos-services/demolition/haute-garonne" path="/nos-services/demolition/haute-garonne" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyDemolitionHauteGaronne />
    </React.Suspense>
  } />,
  <Route key="/nos-services/demolition/tarn" path="/nos-services/demolition/tarn" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyDemolitionTarn />
    </React.Suspense>
  } />,
  <Route key="/nos-services/demolition/lot" path="/nos-services/demolition/lot" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyDemolitionLot />
    </React.Suspense>
  } />,
  <Route key="/nos-services/demolition/cantal" path="/nos-services/demolition/cantal" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyDemolitionCantal />
    </React.Suspense>
  } />,
  <Route key="/nos-services/demolition/lozere" path="/nos-services/demolition/lozere" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyDemolitionLozere />
    </React.Suspense>
  } />,
  <Route key="/nos-services/demolition/herault" path="/nos-services/demolition/herault" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyDemolitionHerault />
    </React.Suspense>
  } />,
  <Route key="/nos-services/demolition/tarn-et-garonne" path="/nos-services/demolition/tarn-et-garonne" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyDemolitionTarnEtGaronne />
    </React.Suspense>
  } />,
  <Route key="/nos-services/demolition/val-doise" path="/nos-services/demolition/val-doise" element={
    <React.Suspense fallback={<div>Chargement...</div>}>
      <LazyDemolitionValDOise />
    </React.Suspense>
  } />
];
